<script>
  export let customer = null;
  export let address = null;
  export let shippingMethod = '';

  $: name =
    (address && (address.name || [address.firstName, address.lastName].filter(Boolean).join(' '))) ||
    (customer && [customer.firstName, customer.lastName].filter(Boolean).join(' ')) ||
    '—';
</script>

<div class="panel">
  <h4>Ship to</h4>
  {#if address}
    <p class="addr">
      <strong>{name}</strong><br />
      {#if address.company}{address.company}<br />{/if}
      {address.address1}<br />
      {#if address.address2}{address.address2}<br />{/if}
      {address.city}{#if address.province}, {address.province}{/if}<br />
      {address.zip}<br />
      {address.country}
    </p>
  {:else}
    <p class="muted">No shipping address.</p>
  {/if}

  {#if customer && (customer.email || customer.phone)}
    <p class="contact">
      {#if customer.email}{customer.email}<br />{/if}
      {#if customer.phone}{customer.phone}{/if}
    </p>
  {/if}

  <p class="ship"><span>Shipping</span> {shippingMethod}</p>
</div>

<style>
  .panel { background: #fff; border: 1px solid #eee; border-radius: 8px; padding: 1rem; }
  h4 { margin: 0 0 .5rem; font-size: .8rem; text-transform: uppercase; letter-spacing: .04em; color: #888; }
  .addr { line-height: 1.45; margin: 0; }
  .contact { margin: .6rem 0 0; font-size: .88rem; color: #555; }
  .ship { margin: .6rem 0 0; font-size: .88rem; }
  .ship span { color: #888; margin-right: .4rem; }
  .muted { color: #777; }
</style>
